/**
 * Files written for the share sheet (native: `Cache/share`) go at app start
 * and whenever a session ends (M11 P2, "leftovers on the device"). Each share
 * still removes the old ones first; the receiving app may read a file after
 * the sheet closes, so a share does not delete its own at once.
 */
import { platform } from '@/platform';
import { logger } from '@/lib/logger';

/** Never rejects: a file left behind is retried at the next start or share. */
export async function clearSharedFiles(): Promise<void> {
  try {
    await platform.share.clearFiles();
  } catch (e) {
    logger.warn('[shared-files] the shared files could not all be removed', e);
  }
}
